import React from 'react';
import { createUseStyles } from 'react-jss';

import classNames from 'classnames';

import * as analytics from 'analytics';
import { isTouch } from 'util/device';
import NewsletterIcon from 'components/svg/Newsletter';

import styles from './NewsletterTile.styles';

interface NewsletterTileProps {
  contentTypeId: string;
  title?: string;
}

const useStyles = createUseStyles(styles, { name: 'NewsletterTile' });
function NewsletterTile({ contentTypeId, title }: NewsletterTileProps): JSX.Element {
  const classes = useStyles();
  return (
    <div
      className={classNames(classes.container, {
        [classes.touchContainer]: isTouch,
        [classes.showTileHeight]: contentTypeId === 'showCollection',
        [classes.tagTileHeight]: contentTypeId === 'genreCollection',
      })}
    >
      <a
        onClick={() =>
          analytics.trackEvent(analytics.generateCTAClickData(`${title}`, '#registrerenlite', 'newsletterTile'))
        }
        href="#registrerenlite"
        className={classes.tileLink}
        type="button"
      >
        <span className={classes.iconContainer}>
          <NewsletterIcon />
        </span>
        <h3 className={classes.title}> Nieuwsbrief ontvangen? </h3>
      </a>
    </div>
  );
}

export default NewsletterTile;
